<template>
    <div v-if="!preloading">
        <label>{{ label }}</label>
        <autocomplete
            :search="search"
            :get-result-value="getResultValue"
            :debounce-time="500"
            :default-value="defaultValue"
            @submit="handleSubmit"
        />
    </div>
</template>

<script>
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import { mapActions } from 'vuex'

    export default {
        components: {
            Autocomplete
        },
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: Number
            }
        },
        data: () => ({
            preloading: true,
            defaultValue: null
        }),
        computed: {
            siteId: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },
        created() {
            if (this.value) {
                this.getSite(this.value)
                    .then(site => {
                        this.defaultValue = site.ndd
                    })
                    .finally(() => {
                        this.preloading = false
                    })
            } else {
                this.preloading = false
            }
        },
        methods: {
            ...mapActions('sites', ['searchSite', 'getSite']),
            search(q) {
                if (q.length < 1) {
                    return []
                }
                return this.searchSite(q)
            },
            getResultValue(result) {
                return result.ndd
            },
            handleSubmit(result) {
                this.siteId = result.id
            }
        }
    }
</script>

<style scoped>
    .autocomplete {
        width: 300px;
    }

    .autocomplete-input {
        width: 100%;
        padding: 5px 10px;
    }

    .autocomplete-result-list {
        z-index: 1;
        background-color: white;
    }

    .autocomplete-result {
        padding: 5px 10px;
    }
</style>
